import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

import { SharedLinkResponse, ExecuteActionResponse } from 'src/models/shared-link.model';

@Injectable({
  providedIn: 'root'
})
export class SharedLinkService {

  private readonly cache = new Map<string, SharedLinkResponse>();
  private readonly pending = new Set<string>();
  readonly cacheSignal = signal<Map<string, SharedLinkResponse>>(new Map());

  constructor(private http: HttpClient) {}

  async getSharedLink(uuid: string): Promise<SharedLinkResponse> {
    return firstValueFrom(
      this.http.get<SharedLinkResponse>(`${environment.api_url}api/v1/tidy-website/shared-links/${uuid}`)
    );
  }

  async fetchAndCache(uuid: string): Promise<void> {
    if (this.cache.has(uuid) || this.pending.has(uuid)) {
      return;
    }
    this.pending.add(uuid);
    try {
      const data = await this.getSharedLink(uuid);
      this.cache.set(uuid, data);
      this.cacheSignal.set(new Map(this.cache));
    } catch (err: any) {
      if (err?.status === 404) {
        const notFound = { shared_link_data: { expired: true, action_type: 'not_found', customer: null } } as SharedLinkResponse;
        this.cache.set(uuid, notFound);
        this.cacheSignal.set(new Map(this.cache));
      }
    } finally {
      this.pending.delete(uuid);
    }
  }

  async executeAction(uuid: string, action: string, actionParams: Record<string, any>): Promise<ExecuteActionResponse> {
    return firstValueFrom(
      this.http.post<ExecuteActionResponse>(`${environment.api_url}api/v1/tidy-website/shared-links/${uuid}/execute-action`, {
        shared_link_uuid: uuid,
        action,
        action_params: actionParams,
      })
    );
  }
}
